import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {
  FilterFormActions,
  FilterFormClearButton,
  FilterFormSubmitButton,
} from 'components/filters/FilterFormButtons';
import useFilterFormContextApplyFiltersStoredValues from 'components/filters/useFilterFormContextApplyFiltersStoredValues';
import useFilterFormContextFormHandlers from 'components/filters/useFilterFormContextFormHandlers';
import PropertySelectField, {
  propertySelectFieldFetchAllQuery,
} from 'components/forms/domain/property/PropertySelectField';
import useFetchAllProperties from 'components/domain/property/useFetchAllProperties';
import { Form } from 'components/forms/form/Form';
import CommonFiltersContainer from 'pages/automations/common/CommonFiltersContainer';
import { AutomatedReviewLogsFiltersSchemaType } from './AutomatedReviewLogsFilters.schema';
import ChannelSelectField from './fields/ChannelSelectField';
import StatusSelectField from './fields/StatusSelectField';
import AutomatedReviewLogsLeadFilter from './AutomatedReviewLogsLeadFilter';
import useSearchedAutomatedReviewLogsLeadUid from './useSearchedAutomatedReviewLogsLeadUid';

const AutomatedReviewLogsFilters = () => {
  const { t } = useTranslation();
  const { handleClear, handleSubmit } =
    useFilterFormContextFormHandlers<AutomatedReviewLogsFiltersSchemaType>();
  const isSearchActive = !!useSearchedAutomatedReviewLogsLeadUid();

  const { allProperties } = useFetchAllProperties({
    enabled: true,
    operationName: 'AutomatedReviewLogsPropertiesAll',
    ...propertySelectFieldFetchAllQuery,
  });

  useFilterFormContextApplyFiltersStoredValues();

  return (
    <CommonFiltersContainer
      stateStorageKey="automated-review-logs-filters-expanded"
      searchField={<AutomatedReviewLogsLeadFilter />}
    >
      <Form
        data-testid="automated-review-logs-filters-form"
        horizontal
        onSubmit={handleSubmit}
      >
        <Row>
          <Col md={4} sm={6}>
            <StatusSelectField
              disabled={isSearchActive}
              label={t(
                'pageAutomations.reviews.automatedReviewLogs.table.status',
              )}
              name="status"
            />
          </Col>
          <Col md={4} sm={6}>
            <ChannelSelectField
              disabled={isSearchActive}
              label={t(
                'pageAutomations.reviews.automatedReviewLogs.table.channel',
              )}
              name="channel"
            />
          </Col>
          <Col md={4} sm={6}>
            <PropertySelectField
              disabled={isSearchActive}
              label={t(
                'pageAutomations.reviews.automatedReviewLogs.table.property',
              )}
              colSmInput={8}
              colSmLabel={4}
              emptyValueLabel={t('common.all')}
              name="propertyUid"
              pictureAsLabel={false}
              properties={allProperties ?? []}
              showUnits={false}
              enableHotels={false}
            />
          </Col>
        </Row>

        <FilterFormActions>
          <FilterFormClearButton onClick={handleClear} />
          <FilterFormSubmitButton disabled={isSearchActive} />
        </FilterFormActions>
      </Form>
    </CommonFiltersContainer>
  );
};

export default AutomatedReviewLogsFilters;
